import React, { useState } from 'react';
import WindowSelectorModal from './windows/WindowSelectorModal';

function App() {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <div>
      <button onClick={() => setModalOpen(true)}>Select Window</button>
      <WindowSelectorModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
      />
    </div>
  );
}

export default App;
